<div mat-dialog-content>
    <form [formGroup]="productForm">
        <div class="form-group">
            <label for="exampleInputEmail1">DPI:</label>
            <input type="text" formControlName="dpi" class="form-control" id="exampleInputEmail1"
                aria-describedby="emailHelp">
        </div>
        <div class="form-group p-0 mt-0">
            <p>Tipo de precalificación:</p>
            <select class="form-control" formControlName="tipoPrecalificacion">
                <option *ngIf="data.permisoCredito" value="credito_fiduciario">Crédito Fiduciario</option>
                <option *ngIf="data.permisoTC" value="tarjeta_credito">Tarjeta de Crédito</option>
                <option *ngIf="data.permisoMixto" value="credito_mixto">Crédito Mixto</option>
            </select>
          </div>
        <div class="row m-0" >
            <div class="col-md-12">
                <div style="text-align: center;">
                    <button class="btn round-button" (click)="goToDatosGenerales()">Continuar</button>
                </div>
            </div>
        </div>
    </form>
</div>